export default {
  title: "Individuelle Auswertungen",
  results: "Ergebnisse",
  notification: {
    save: {
      type: 'success',
      message: 'Auswertung erfolgreich gespeichert',
      title: 'Erfolgreich gespeichert'
    },
    delete: {
      type: 'success',
      message: 'Auswertung erfolgreich gelöscht',
      title: 'Erfolgreich gelöscht'
    }
  }
}
